(function () {
  var SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.css';
  var SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.js';
  var loadingPromise = null;

  function loadStylesheet(href) {
    if (document.querySelector('link[href="' + href + '"]')) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = resolve;
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    if (typeof window.Swiper !== 'undefined') return Promise.resolve();
    if (document.querySelector('script[src="' + src + '"]')) {
      return new Promise(function (resolve) {
        var check = function () {
          if (typeof window.Swiper !== 'undefined') resolve();
          else setTimeout(check, 50);
        };
        check();
      });
    }
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function ensureSwiper() {
    if (typeof window.Swiper !== 'undefined') return Promise.resolve();
    if (loadingPromise) return loadingPromise;
    loadingPromise = Promise.all([loadStylesheet(SWIPER_CSS), loadScript(SWIPER_JS)]).then(function () {
      return new Promise(function (resolve) {
        var check = function () {
          if (typeof window.Swiper !== 'undefined') resolve();
          else setTimeout(check, 30);
        };
        check();
      });
    });
    return loadingPromise;
  }

  /**
   * Grid columns often get fractional widths (e.g. 333.33px).
   * Lock the Swiper root to a whole-pixel width so slides don't leave a 1–2px gap.
   */
  function lockIntegerWidth(el) {
    el.style.width = '';
    var measured = el.getBoundingClientRect().width;
    if (!measured) return 0;
    var width = Math.floor(measured);
    el.style.width = width + 'px';
    return width;
  }

  function initCarousel(el) {
    if (!el || el.dataset.swiperInit === 'true' || typeof window.Swiper === 'undefined') return;
    if (el.swiper) return;

    el.dataset.swiperInit = 'true';
    lockIntegerWidth(el);

    var swiper = new window.Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 350,
      loop: true,
     
      watchOverflow: true,
      nested: true,
      observer: true,
      observeParents: true,
      pagination: {
        el: el.querySelector('.product-card__swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: el.querySelector('.product-card__swiper-next'),
        prevEl: el.querySelector('.product-card__swiper-prev')
      },
      on: {
        init: function () {
          el.classList.add('is-ready');
        }
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      var resizeTimer;
      var ro = new ResizeObserver(function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          lockIntegerWidth(el);
          if (swiper && !swiper.destroyed) {
            swiper.update();
          }
        }, 50);
      });
      ro.observe(el.parentElement || el);
    }
  }

  function initAll(root) {
    var scope = root || document;
    var carousels = scope.querySelectorAll
      ? scope.querySelectorAll('.product-card__swiper:not([data-swiper-init="true"])')
      : [];

    if (!carousels.length) return;

    ensureSwiper().then(function () {
      carousels.forEach(initCarousel);
    }).catch(function () {});
  }

  function observeNewCards() {
    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function (mutations) {
      var shouldInit = false;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (
            (node.matches && node.matches('.product-card__swiper')) ||
            (node.querySelector && node.querySelector('.product-card__swiper'))
          ) {
            shouldInit = true;
          }
        });
      });
      if (shouldInit) initAll(document);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
      observeNewCards();
    });
  } else {
    initAll(document);
    observeNewCards();
  }

  window.initProductCardSwipers = initAll;
})();
